import { useId } from 'react'

type BorderProps = {    
  className?: string
}

export const Border = ({ className }: BorderProps) => {
  const maskId = useId()
  const gradient1Id = useId()
  const maskDId = useId()
  const maskGId = useId()
  const filterIId = useId()
  const filterLId = useId()
  const gradientEId = useId()
  const gradientHId = useId()
  const gradientKId = useId()
  const gradientCId = useId()
  const gradientFId = useId()
  const gradientJId = useId()

  return (
    <svg viewBox="0 0 43 447" fill="none" className={className}>
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-10"
        y="0"
        width="53"
        height="447"
      >
        <path fill={`url(#${gradient1Id})`} d="M-9.104.504h51.375v446.14H-9.104z" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <g opacity=".5">
          <mask id={maskDId} fill="#fff">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.18-136.212c0-15.767-12.782-28.549-28.55-28.549h-22.903c-15.767 0-28.549 12.782-28.549 28.549v583.949c0 15.767 12.782 28.549 28.55 28.549h22.903c15.767 0 28.549-12.782 28.549-28.549v-5.743c0-11.981 8.597-22.685 14.328-33.207 3.172-5.823 5.044-12.996 5.044-20.754s-1.872-14.932-5.044-20.755c-5.731-10.521-14.328-21.226-14.328-33.207z"
            />
          </mask>
          <path
            d="m24.508 367.278-1.027.56zm0 41.509 1.027.56zm-65.78-572.378h22.903v-2.34h-22.904zm-27.38 611.328v-583.949h-2.34v583.949zm50.283 27.379h-22.904v2.34h22.904zM9.01 441.994v5.743h2.34v-5.743zm19.371-53.961c0 7.573-1.827 14.553-4.9 20.195l2.054 1.119c3.271-6.004 5.187-13.371 5.187-21.314zm-4.9-20.195c3.073 5.642 4.9 12.621 4.9 20.195h2.34c0-7.944-1.915-15.311-5.186-21.315zM9.01-136.212v470.283h2.34v-470.283zm16.526 502.93c-1.449-2.658-3.077-5.326-4.683-7.987-1.612-2.671-3.207-5.342-4.621-8.051-2.832-5.424-4.882-10.896-4.882-16.609H9.01c0 6.268 2.248 12.138 5.148 17.692 1.451 2.781 3.08 5.508 4.692 8.177 1.617 2.68 3.213 5.296 4.63 7.898zM11.35 441.994c0-5.713 2.05-11.185 4.882-16.609 1.414-2.709 3.009-5.379 4.621-8.051 1.606-2.661 3.234-5.329 4.682-7.987l-2.055-1.119c-1.417 2.602-3.013 5.217-4.63 7.897-1.612 2.669-3.241 5.397-4.693 8.177-2.9 5.554-5.147 11.424-5.147 17.692zm-29.72 35.462c16.414 0 29.72-13.306 29.72-29.719H9.01c0 15.121-12.258 27.379-27.38 27.379zm-52.622-29.719c0 16.413 13.306 29.719 29.72 29.719v-2.34c-15.122 0-27.38-12.258-27.38-27.379zm52.623-611.328c15.12 0 27.379 12.258 27.379 27.379h2.34c0-16.413-13.306-29.719-29.72-29.719zm-22.904-2.34c-16.413 0-29.719 13.306-29.719 29.719h2.34c0-15.121 12.258-27.379 27.38-27.379z"
            fill={`url(#${gradientCId})`}
            mask={`url(#${maskDId})`}
          />
          <path
            d="m24.508 367.278-1.027.56zm0 41.509 1.027.56zm-65.78-572.378h22.903v-2.34h-22.904zm-27.38 611.328v-583.949h-2.34v583.949zm50.283 27.379h-22.904v2.34h22.904zM9.01 441.994v5.743h2.34v-5.743zm19.371-53.961c0 7.573-1.827 14.553-4.9 20.195l2.054 1.119c3.271-6.004 5.187-13.371 5.187-21.314zm-4.9-20.195c3.073 5.642 4.9 12.621 4.9 20.195h2.34c0-7.944-1.915-15.311-5.186-21.315zM9.01-136.212v470.283h2.34v-470.283zm16.526 502.93c-1.449-2.658-3.077-5.326-4.683-7.987-1.612-2.671-3.207-5.342-4.621-8.051-2.832-5.424-4.882-10.896-4.882-16.609H9.01c0 6.268 2.248 12.138 5.148 17.692 1.451 2.781 3.08 5.508 4.692 8.177 1.617 2.68 3.213 5.296 4.63 7.898zM11.35 441.994c0-5.713 2.05-11.185 4.882-16.609 1.414-2.709 3.009-5.379 4.621-8.051 1.606-2.661 3.234-5.329 4.682-7.987l-2.055-1.119c-1.417 2.602-3.013 5.217-4.63 7.897-1.612 2.669-3.241 5.397-4.693 8.177-2.9 5.554-5.147 11.424-5.147 17.692zm-29.72 35.462c16.414 0 29.72-13.306 29.72-29.719H9.01c0 15.121-12.258 27.379-27.38 27.379zm-52.622-29.719c0 16.413 13.306 29.719 29.72 29.719v-2.34c-15.122 0-27.38-12.258-27.38-27.379zm52.623-611.328c15.12 0 27.379 12.258 27.379 27.379h2.34c0-16.413-13.306-29.719-29.72-29.719zm-22.904-2.34c-16.413 0-29.719 13.306-29.719 29.719h2.34c0-15.121 12.258-27.379 27.38-27.379z"
            fill={`url(#${gradientEId})`}
            mask={`url(#${maskDId})`}
          />
        </g>
        <mask id={maskGId} fill="#fff">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.183-59.776c0-13.476-10.924-24.4-24.4-24.4h-19.575c-13.475 0-24.4 10.924-24.4 24.4v499.077c0 13.476 10.925 24.4 24.4 24.4h19.575c13.476 0 24.4-10.925 24.4-24.4v-.902c0-10.253 7.197-19.666 11.912-28.77 3.021-5.832 4.83-13.262 4.83-21.355s-1.809-15.522-4.83-21.354c-4.715-9.104-11.912-18.517-11.912-28.771z"
          />
        </mask>
        <path
          d="M-37.792-83.176h19.575v-2h-19.575zm-23.4 522.477V-59.776h-2v499.077zm42.975 23.4h-19.575v2h19.575zm23.4-24.302v.902h2v-.902zm16.743-50.125c0 7.95-1.779 15.22-4.718 20.895l1.775.92c3.102-5.989 4.943-13.58 4.943-21.815zm-4.718-20.894c2.939 5.675 4.718 12.945 4.718 20.894h2c0-8.235-1.84-15.826-4.943-21.814zM5.182-59.776v397.925h2V-59.776zm13.8 426.236c-1.191-2.3-2.538-4.618-3.872-6.933-1.338-2.325-2.667-4.652-3.846-7.009-2.363-4.721-4.082-9.472-4.082-14.369h-2c0 5.357 1.879 10.439 4.293 15.264 1.21 2.416 2.565 4.79 3.902 7.112 1.342 2.33 2.663 4.603 3.83 6.855zm-11.8 71.939c0-4.897 1.72-9.647 4.082-14.368 1.18-2.357 2.508-4.685 3.846-7.009 1.334-2.315 2.68-4.633 3.872-6.933l-1.776-.92c-1.166 2.251-2.487 4.525-3.829 6.855-1.337 2.322-2.693 4.696-3.902 7.112-2.414 4.825-4.293 9.907-4.293 15.263zm-25.4 26.302c14.028 0 25.4-11.372 25.4-25.4h-2c0 12.923-10.477 23.4-23.4 23.4zm-44.974-25.4c0 14.028 11.371 25.4 25.4 25.4v-2c-12.924 0-23.4-10.477-23.4-23.4zm44.974-522.477c12.923 0 23.4 10.477 23.4 23.4h2c0-14.028-11.372-25.4-25.4-25.4zm-19.575-2c-14.028 0-25.4 11.372-25.4 25.4h2c0-12.923 10.477-23.4 23.4-23.4z"
          fill={`url(#${gradientFId})`}
          mask={`url(#${maskGId})`}
        />
        <path
          d="M-37.792-83.176h19.575v-2h-19.575zm-23.4 522.477V-59.776h-2v499.077zm42.975 23.4h-19.575v2h19.575zm23.4-24.302v.902h2v-.902zm16.743-50.125c0 7.95-1.779 15.22-4.718 20.895l1.775.92c3.102-5.989 4.943-13.58 4.943-21.815zm-4.718-20.894c2.939 5.675 4.718 12.945 4.718 20.894h2c0-8.235-1.84-15.826-4.943-21.814zM5.182-59.776v397.925h2V-59.776zm13.8 426.236c-1.191-2.3-2.538-4.618-3.872-6.933-1.338-2.325-2.667-4.652-3.846-7.009-2.363-4.721-4.082-9.472-4.082-14.369h-2c0 5.357 1.879 10.439 4.293 15.264 1.21 2.416 2.565 4.79 3.902 7.112 1.342 2.33 2.663 4.603 3.83 6.855zm-11.8 71.939c0-4.897 1.72-9.647 4.082-14.368 1.18-2.357 2.508-4.685 3.846-7.009 1.334-2.315 2.68-4.633 3.872-6.933l-1.776-.92c-1.166 2.251-2.487 4.525-3.829 6.855-1.337 2.322-2.693 4.696-3.902 7.112-2.414 4.825-4.293 9.907-4.293 15.263zm-25.4 26.302c14.028 0 25.4-11.372 25.4-25.4h-2c0 12.923-10.477 23.4-23.4 23.4zm-44.974-25.4c0 14.028 11.371 25.4 25.4 25.4v-2c-12.924 0-23.4-10.477-23.4-23.4zm44.974-522.477c12.923 0 23.4 10.477 23.4 23.4h2c0-14.028-11.372-25.4-25.4-25.4zm-19.575-2c-14.028 0-25.4 11.372-25.4 25.4h2c0-12.923 10.477-23.4 23.4-23.4z"
          fill={`url(#${gradientHId})`}
          mask={`url(#${maskGId})`}
        />
        <g filter={`url(#${filterIId})`} fillRule="evenodd" clipRule="evenodd">
          <path
            d="M1.474 20.504c0-11.046-8.954-20-20-20H-34.57c-11.046 0-20 8.954-20 20v418.83c0 11.046 8.954 20 20 20h16.045c11.046 0 20-8.954 20-20v-6.398c0-10.113 8.098-20.547 11.503-30.07 1.55-4.335 2.452-9.525 2.452-15.102 0-5.578-.902-10.767-2.452-15.103-3.405-9.522-11.503-19.956-11.503-30.069z"
            fill={`url(#${gradientJId})`}
            fillOpacity=".2"
          />
          <path
            d="M1.474 20.504c0-11.046-8.954-20-20-20H-34.57c-11.046 0-20 8.954-20 20v418.83c0 11.046 8.954 20 20 20h16.045c11.046 0 20-8.954 20-20v-6.398c0-10.113 8.098-20.547 11.503-30.07 1.55-4.335 2.452-9.525 2.452-15.102 0-5.578-.902-10.767-2.452-15.103-3.405-9.522-11.503-19.956-11.503-30.069z"
            fill={`url(#${gradientKId})`}
          />
        </g>
        <g filter={`url(#${filterLId})`}>
          <ellipse
            cx="-9.103"
            cy="388.719"
            rx="16.578"
            ry="26.128"
            fill="#fff"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id={gradient1Id}
          x1="16.584"
          y1=".504"
          x2="16.584"
          y2="446.644"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".041" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset=".557" stopColor="#D9D9D9" />
          <stop offset=".885" stopColor="#737373" />
          <stop offset="1" stopColor="#737373" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={gradientEId}
          x1="20.298"
          y1="416.5"
          x2="15.327"
          y2="460.321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id={gradientHId}
          x1="15.685"
          y1="412.605"
          x2="11.437"
          y2="450.056"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id={gradientKId}
          x1="11.2"
          y1="416.543"
          x2="7.671"
          y2="447.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
        <radialGradient
          id={gradientCId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 -429.606 10983.1 0 36.38 391.131)"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id={gradientFId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 -367.167 9386.78 0 37.547 390.666)"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id={gradientJId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 -307.492 7927.66 0 31.71 398.51)"
        >
          <stop stopColor="#fff" />
          <stop offset="1" />
        </radialGradient>
        <filter
          id={filterIId}
          x="-54.571"
          y=".504"
          width="70"
          height="458.83"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow_133_1271" />
        </filter>
        <filter
          id={filterLId}
          x="-38.682"
          y="349.591"
          width="59.157"
          height="78.257"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation="6.5"
            result="effect1_foregroundBlur_133_1271"
          />
        </filter>
      </defs>
    </svg>
  )
}
